/**
 * @description 登录、获取用户信息、退出登录、清除token逻辑，不建议修改
 */
import { useRoutesStore } from './routes';
// import { useSettingsStore } from './settings'
import { getUserInfo, login, logout, socialLogin, mobileLogin } from '@/api/user';
import { wechatBind } from '@/api/seeting';
import { getToken, removeToken, setToken } from '@/utils/token';
import { resetRouter } from '@/router';
import { isArray, isString } from '@/utils/validate';
import { tokenName } from '@/config';
import { gp } from '@gp';
import { ElMessage } from 'element-plus';
export const useUserStore = defineStore('user', {
  state: () => ({
    token: getToken(),
    username: '游客',
    hasHomePermission: true // 是否有首页权限
    // avatar: require('@/assets/img/user.gif'),
  }),
  getters: {
    getToken: state => state.token,
    getUsername: state => state.username,
    getAvatar: state => state.avatar,
    getHasHomePermission: state => state.hasHomePermission
  },
  actions: {
    /**
     * @description 设置token
     * @param {*} token
     */
    setToken(token) {
      this.token = token;
      setToken(token);
    },
    /**
     * @description 设置用户名
     * @param {*} username
     */
    setUsername(username) {
      this.username = username;
    },
    /**
     * @description 设置头像
     * @param {*} avatar
     */
    setAvatar(avatar) {
      this.avatar = avatar;
    },
    /**
     * @description 登录拦截放行时，设置虚拟角色
     */
    setVirtualRoles() {
      // const aclStore = useAclStore()
      // aclStore.setFull(true)
      this.commit('admin(未开启登录拦截)');
      // this.setAvatar(require('@/assets/img/user.gif'))
    },
    /**
     * @description 设置token并发送提醒
     * @param {string} token 更新令牌
     * @param {string} tokenName 令牌名称
     */
    afterLogin(token, tokenName) {
      // const settingsStore = useSettingsStore()
      if (token) {
        this.setToken(token);
        /* const hour = new Date().getHours()
        const thisTime =
          hour < 8
            ? '早上好'
            : hour <= 11
            ? '上午好'
            : hour <= 13
            ? '中午好'
            : hour < 18
            ? '下午好'
            : '晚上好' */
        ElMessage({
          message: '登录成功，欢迎您，管理员！！！',
          type: 'success',
          offset: 72,
          duration: 1000
        });
        // gp.$baseNotify(`欢迎登录${settingsStore.title}`, `${thisTime}！`)
      } else {
        const err = `登录接口异常，未正确返回${tokenName}...`;
        gp.$baseMessage(err, 'error', 'vab-hey-message-error');
        throw err;
      }
    },
    /**
     * @description 登录
     * @param {*} userInfo
     */
    async login(userInfo, type) {
      console.log('userInfo', userInfo, type);
      const {
        data: {
          [tokenName]: token
        }
      } = type == 2 ? await mobileLogin(userInfo) : await login(userInfo);
      this.afterLogin(token, tokenName);
      this.getUserInfo();
    },
    async smLogin(userInfo) {
      const {
        data: {
          [tokenName]: token
        }
      } = await wechatBind(userInfo);
      this.afterLogin(token, tokenName);
    },
    /**
     * @description 第三方登录
     * @param {*} tokenData
     */
    async socialLogin(tokenData) {
      const {
        data: {
          [tokenName]: token
        }
      } = await socialLogin(tokenData);
      this.afterLogin(token, tokenName);
    },
    async getUserInfo() {
      const {
        data: {
          username,
          avatar,
          roles,
          permissions,
          hasHomePermission
        }
      } = await getUserInfo();
      /**
       * 检验返回数据是否正常，无对应参数，将使用默认用户名,头像,Roles和Permissions
       * username {String}
       * avatar {String}
       * roles {List}
       * ability {List}
       */
      if (username && !isString(username) || avatar && !isString(avatar) || roles && !isArray(roles) || permissions && !isArray(permissions)) {
        const err = 'getUserInfo核心接口异常，请检查返回JSON格式是否正确';
        gp.$baseMessage(err, 'error', 'vab-hey-message-error');
        throw err;
      } else {
        // const aclStore = useAclStore()
        // 如不使用username用户名,可删除以下代码
        if (username) this.setUsername(username);
        // 如不使用avatar头像,可删除以下代码
        if (avatar) this.setAvatar(avatar);
        // 保存首页权限状态
        this.hasHomePermission = hasHomePermission !== false;
        // 如不使用roles权限控制,可删除以下代码
        // if (roles) aclStore.setRole(roles)
        // 如不使用permissions权限控制,可删除以下代码
        // if (permissions) aclStore.setPermission(permissions)
        // if (role) localStorage.setItem('userRole', role)
        // if (id) localStorage.setItem('adminsId', id)
      }
    },
    /**
     * @description 退出登录
     */
    async logout() {
      await logout();
      await this.resetAll();
    },
    /**
     * @description 重置token、roles、permission、router、tabsBar等
     */
    async resetAll() {
      this.setToken(null);
      this.setUsername('游客');
      // this.setAvatar(require('@/assets/img/user.gif'))

      // const aclStore = useAclStore()
      const routesStore = useRoutesStore();
      // aclStore.setFull(false)
      // aclStore.setRole([])
      // aclStore.setPermission([])
      routesStore.clearRoutes();
      await resetRouter();
      removeToken();
    }
  }
});